export const waitV2DocumentationMarkdown = `
# Wait for/until time

Waits for a specified amount of time.

The amount of time to wait can be defined as either:
 - a pre-defined wait duration; or
 - a dynamic wait duration or target datetime until which to wait.

Only one of the above values can be specified.

## Pre-defined wait duration

Pre-defined duration can be specified in any of the following units using the unit selection menu:

- Years
- Weeks
- Days
- Hours
- Minutes
- Seconds

## Dynamic wait duration or target datetime

**Dynamic** means either:
- a pre-defined value; or
- using an output value from a previous block via \`{{...}}\` notation (e.g., \`{{scriptBlock.waitDuration}}\`).

The value must be either:
- number of milliseconds to wait (e.g., \`15000\`); or
- an [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) formatted target datetime until which to wait (e.g., \`2025-09-22T17:40:15Z\`).

Here are some examples of ISO 8601 datetimes:

- **5:40 PM in UTC:** \`2025-09-22T17:40:00Z\`
- **7:40 AM PDT (UTC-7):** \`2025-09-22T07:40:00-07:00\`
- **5:40 PM in UTC+2 Timezone:** \`2025-09-22T17:40:00+02:00\`

## Random extra wait

**When to use it:** many runs of the flow reach this block around the same time, such as a flow started for a batch of patients, and a later block calls another system like a FHIR API. Without an extra wait, they all resume at the same moment and send their requests at once, which can overload that system or trip its rate limits.

**How it works:** each run waits an extra random amount, from zero up to the value you set, on top of the wait above. For example, a 5 second wait plus an extra wait of up to 10 seconds resumes each run somewhere between 5 and 15 seconds.

**Good to know:** the extra wait only adds time, and it still applies when a target datetime has already passed.
`;
